const options = {
    resizableColumns: true,
    perPage: 10,
    perPageValues: [5, 10, 50, 100],
    pagination: { chunk: 5 },
    datepickerOptions: {
        showDropdowns: true,
        autoUpdateInput: true
    },
    sortIcon: {
        base: 'fa float-right',
        is: 'fa-sort',
        up: 'fa-sort-up',
        down: 'fa-sort-down'
    },
    texts: {
        count: `${$t(
                'Showing {from} to {to} of {count} records|{count} records|One record'
        )}`,
        first: `${$t('First')}`,
        last: `${$t('Last')}`,
        filter: `${$t('Filter')}:`,
        filterPlaceholder: `${$t('Search query')}`,
        limit: `${$t('Records')}:`,
        page: `${$t('Page')}:`,
        noResults: `${$t('No matching records')}`,
        filterBy: `${$t('Filter by {column}')}`,
        loading: `${$t('Loading')}...`,
        defaultOption: `${$t('Select {column}')}`,
        columns: `${$t('Columns')}`
    },
    columnsDisplay: {}
    // columnsDropdown: true,
    // columnsDisplay: {
    //     email: 'min_tabletP',
    //     id: 'min_tabletP'
    // },
    // selectable:{
    //     mode: 'multiple', // or 'multiple'
    //     only: function(row) {
    //         return true // any condition
    //     },
    //     selectAllMode: 'all', // or 'page',
    //     programmatic: false
    // }
}

export default {
    options
}